import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { RAGStatus } from "./enums/Result";
import RAGStatusChip from "../results/RAGStatusChip";

interface Props {
  options: ColumnFilterElementTemplateOptions;
}

const ragStatusDropdownItemTemplate = (ragStatus: RAGStatus) => {
  return <RAGStatusChip ragStatus={ragStatus} />;
};

export function RAGStatusFilterDropdown(props: Props) {
  return (
    <Dropdown
      value={props.options.value}
      options={Object.values(RAGStatus)}
      onChange={(e) => props.options.filterApplyCallback(e.value)}
      className="w-100"
      showClear
      itemTemplate={ragStatusDropdownItemTemplate}
      valueTemplate={ragStatusDropdownItemTemplate}
    />
  );
}
